// app-celular.js — decisión pura del pop-up "Lleva SmartDx a tu celular" (#1686, fase 2a).
//
// Cubre R25, R26, R27 — .claude/specs/1686-checklist-uso-celular/
//
// El backend decide `mostrar` (la checklist vive allá: `/me` → `app_celular`); el front solo suma lo que
// el servidor no sabe: el aparato, la pantalla y qué otra cosa tiene abierta la persona. Sin React, para
// poder probarla suelta (patrón de `tutorialPrimerDoc.js`); el único import es otra regla pura (D14, abajo).
import { tutorialCamasPendiente } from "./tutorialCamas";

// La misma URL que dibuja el QR. La matriz de `components/pwa/qrLogin.js` la genera
// `scripts/generar-qr-login.js` con ESTA constante: si una cambia, se regenera la otra (el e2e R32
// compara la matriz contra `qrcode.create(URL_LOGIN_APP)`).
export const URL_LOGIN_APP = "https://app.smardx.com/authentication";

// D9: solo en las rutas de aterrizaje, como el rescate de inactivos (`RUTAS_REINTRO`). No interrumpe
// /perfil, /admin ni un diálogo de pago.
export const RUTAS_POPUP_CELULAR = ["/", "/home", "/turno"];

// D14: el pop-up obligatorio de camas (#1664) sale a la MISMA población y va primero: mientras a la cuenta
// le toque ese tutorial, este espera. La regla es `tutorialCamasPendiente` de tutorialCamas.js, la MISMA que
// usa `decidirTutorialCamas`, y no una copia: la copia que vivía acá no miraba Modo Turno ni superuser, y a
// una cuenta sin Modo Turno con 3+ documentos (el tutorial vive en /turno y nunca le abre) el pop-up del
// celular no le salía nunca (W3 del revisor p4 de #1664, 17-oct; 2 cuentas medidas en prod). Campo AUSENTE
// (backend sin #1664) = "no esperar"; quien ya sincronizó camas (`ha_sincronizado_camas`, #1664 R25) no espera.
// R27 v2 de .claude/specs/1686-checklist-uso-celular/ (Sebastián, 15-oct).
export const camasPendiente = tutorialCamasPendiente;

// `gateDeAlta`: hubo (o hay) un overlay de alta en esta carga, ver `hooks/useHuboGateDeAlta`.
// `tutorialAbierto`: hay (o hubo en esta carga) un tutorial, un diálogo de Turno (el selector diario, visto en el DOM o por la señal "con_dialogo" de turno-arranque.js),
// o el rescate de inactivos. Nombre histórico: es "otro pop-up", D14.
// `cerradoEnEstaCarga`: la persona ya tocó "Ahora no" / "Ya la tengo" (también si el POST falló).
export const decidirPopupCelular = ({
  user,
  computador,
  ruta,
  gateDeAlta = false,
  tutorialAbierto = false,
  cerradoEnEstaCarga = false,
}) =>
  user?.app_celular?.mostrar === true &&
  Boolean(computador) &&
  RUTAS_POPUP_CELULAR.includes(ruta) &&
  !gateDeAlta &&
  !tutorialAbierto &&
  !camasPendiente(user) &&
  !cerradoEnEstaCarga;

// Texto del contador (R33): `veces_restantes` viene de `/me`, 2 en la primera aparición.
export const textoContador = (n) => {
  if (n >= 2) return `Te lo recordamos ${n} veces más`;
  if (n === 1) return "Te lo recordamos 1 vez más";
  return "Esta es la última vez que te lo mostramos";
};
